export default __webpack_public_path__ + "static/media/ncr.bf607d7b.jfif";